import { computed, Injectable, Signal, signal } from "@angular/core";

@Injectable({
  providedIn: 'root'
})

export class DateService{
    private today = signal(new Date())
    getDaysRemaining(targetDateString: string): Signal<number> {
      const targetDate = new Date(targetDateString);
      const timeDiff = targetDate.getTime() - this.today().getTime();
      const days = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
      return signal(days);
    }
}